export default __webpack_public_path__ + "static/media/Inbox.2b0774fe.png";